import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../config/employeeApiConfig';
import { PolicyCategoryState , PolicyCategory } from './policyCategoryTypes';



export const createPolicyCategory = createAsyncThunk(
    'policyCategory/createPolicy',
    async (data: any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.post('/policycategory', data);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create termination');
      }
    }
  );
  export const FetchAllPolicyCategory = createAsyncThunk(
    'Policycategorys/fetchallpolicycategory',
    async (_, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get('/policycategory');          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch policy');
      }
    }
  );
  export const FetchPolicyCategoryById = createAsyncThunk(
    'policyCategorys/fetchallpolicycategory',
    async (Id : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.get(`/policycategory/${Id}`);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch policy By Id');
      }
    }
  );
   export const UpdatePolicyCategory = createAsyncThunk<any , {Id: number; data: any}, { rejectValue: string }>(
    'termination/updateTermination',
    async ({Id , data}: {Id : Number; data: Partial<any>}, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.put(`/policycategory/${Id}`, data)
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to create termination');
      }
    }
  ); 

  export const DeletePolicyCategory = createAsyncThunk(
    'policycategory/deletepolicycategory',
    async (Id : any, { rejectWithValue }) => {
      try {  
        const response = await employeeServiceApiInstance.delete(`/policycategory/${Id}`);          
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to Delete');
      }
    }
  );